import { useState } from "react";

export function useLocalStorage<T>(key: string, defaultValue: T) {
  const [state, setState] = useState<T>(() => {
    const item = localStorage.getItem(key);
    if (item === null) return defaultValue;

    try {
      const deserialized = JSON.parse(item);
      return deserialized;
    } catch {
      return item;
    }
  });

  const setValue = (value: T) => {
    setState(value);
    if (typeof value === "string") {
      localStorage.setItem(key, value);
    } else {
      const serialized = JSON.stringify(value);
      localStorage.setItem(key, serialized);
    }
  };

  const removeValue = () => setValue(defaultValue);

  return [state, setValue, removeValue] as const;
}
